(function ($) {
    'use_strict';
    /**
     * Creates the contact forms
     */

    var form = m4_form;
    var service_form= [];
    var errorMsg = new message("danger");
    var succesMsg = new message("success");
    var translate = m4;
    
    $(document).ready(function () {
        $("body").find("form.service-form").each(function () {
            service_form.push(new form.create_form($(this), form.service_success, form.service_fail));
        });  
    }); 

    form.service_success = function (data,the_form) {
        the_form.resetForm();  
        succesMsg.removeAllMsg();
        errorMsg.removeAllMsg();
        succesMsg.createMessage(data); 
        succesMsg.display();
    };

    form.service_fail = function (data) {
        succesMsg.removeAllMsg();
        errorMsg.removeAllMsg();
        errorMsg.createMessage(data.data);
        errorMsg.display();
    }; 
     
})(jQuery);